import { useEffect, useRef, useState } from 'react';

/**
 * Aviso no bloqueante: campo editable + «Omitir y continuar».
 */
export default function ModalAvisoContactoSoft({
  open,
  mensaje,
  fieldLabel,
  value: valueInicial = '',
  inputType = 'text',
  onOmitir,
}) {
  const [valor, setValor] = useState(valueInicial);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setValor(valueInicial);
      setTimeout(() => {
        const el = inputRef.current;
        if (!el) return;
        const active = document.activeElement;
        if (active && active !== el && typeof active.blur === 'function') {
          try { active.blur(); } catch { /* noop */ }
        }
        try {
          el.focus({ preventScroll: true });
          const len = el.value.length;
          el.setSelectionRange(len, len);
        } catch { /* noop */ }
      }, 50);
    }
  }, [open, valueInicial]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        zIndex: 25000,
        background: 'rgba(15, 23, 42, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'max(12px, env(safe-area-inset-top)) 16px max(16px, env(safe-area-inset-bottom))',
        overflowY: 'auto',
        fontFamily: "'DM Sans', sans-serif",
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onOmitir?.(valor); }}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 420,
          margin: 'auto',
          background: '#fff',
          borderRadius: 14,
          padding: '18px 18px 16px',
          boxShadow: '0 20px 50px rgba(0,0,0,0.25)',
          border: '2px solid #f59e0b',
        }}
      >
        <div style={{ fontSize: 15, fontWeight: 800, color: '#b45309', marginBottom: 8 }}>
          Revisar dato
        </div>
        <div style={{ fontSize: 14, color: '#334155', lineHeight: 1.45, marginBottom: 14 }}>
          {mensaje}
        </div>
        <label style={{
          display: 'block',
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: '#64748b',
          marginBottom: 6,
        }}
        >
          {fieldLabel}
        </label>
        <input
          ref={inputRef}
          type={inputType}
          value={valor}
          onChange={(e) => setValor(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              onOmitir?.(valor);
            }
          }}
          style={{
            width: '100%',
            boxSizing: 'border-box',
            padding: '10px 12px',
            borderRadius: 10,
            border: '2px solid #e2e8f0',
            fontSize: 14,
            fontFamily: 'inherit',
            marginBottom: 14,
            outline: 'none',
            WebkitTapHighlightColor: 'transparent',
            boxShadow: 'none',
          }}
          onFocus={(e) => {
            const len = e.target.value.length;
            try { e.target.setSelectionRange(len, len); } catch { /* noop */ }
          }}
        />
        <button
          type="button"
          onClick={() => onOmitir?.(valor)}
          style={{
            width: '100%',
            padding: '11px 14px',
            borderRadius: 10,
            border: 'none',
            background: '#1a3c6e',
            color: '#fff',
            fontWeight: 700,
            fontSize: 14,
            cursor: 'pointer',
            fontFamily: 'inherit',
          }}
        >
          Omitir y continuar
        </button>
      </div>
    </div>
  );
}
